module.exports = __webpack_public_path__ + "img/desktop.c4df1fb3.jpg";